import { createReactComponent } from './react-component-lib';
import { defineCustomElements } from '@facephi/sdk-video-recruitment/loader';
defineCustomElements();
export const ButtonComponent = createReactComponent('button-component');
export const ButtonIcon = createReactComponent('button-icon');
export const CapturedContainer = createReactComponent('captured-container');
export const CheckCircleIcon = createReactComponent('check-circle-icon');
export const CloseCircleIcon = createReactComponent('close-circle-icon');
export const CloseIcon = createReactComponent('close-icon');
export const CustomIcon = createReactComponent('custom-icon');
export const HourglassLowIcon = createReactComponent('hourglass-low-icon');
export const IdentificationCardBackIcon = createReactComponent('identification-card-back-icon');
export const IdentificationCardIcon = createReactComponent('identification-card-icon');
export const InstrutionsContainer = createReactComponent('instrutions-container');
export const LoadingContainer = createReactComponent('loading-container');
export const LottieAnimation = createReactComponent('lottie-animation');
export const ModalBase = createReactComponent('modal-base');
export const ModalStart = createReactComponent('modal-start');
export const ModalState = createReactComponent('modal-state');
export const ScreenLayout = createReactComponent('screen-layout');
export const UserFocusIcon = createReactComponent('user-focus-icon');
export const VideoContainer = createReactComponent('video-container');
export const VideoRecruitment = createReactComponent('video-recruitment');
export const WarningCircleIcon = createReactComponent('warning-circle-icon');
